import API from './apiClient';

export const uploadFile = async (data) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        const response = await API.post('/upload', data, config);
        return response.data;
    } catch (error) {
        throw error;
    }
};
